// src/api/home/salesCogsFilterApi.js
import axiosClient from '../axiosClient';

export const salesCogsFilterApi = {

    getCategories: async () => {
        const data = await axiosClient.get('/sales-cogs/filters/categories');
        return data || [];
    },

    getCustomers: async () => {
        const data = await axiosClient.get('/sales-cogs/filters/customers');
        return data || [];
    },

    getSalesEmployees: async () => {
        const data = await axiosClient.get('/sales-cogs/filters/sales-employees');
        return data || [];
    },

    getContactPersons: async () => {
        const data = await axiosClient.get('/sales-cogs/filters/contact-persons');
        return data || [];
    },

    getItems: async (search = '') => {
        const data = await axiosClient.get(
            `/sales-cogs/filters/items?search=${encodeURIComponent(search)}`
        );
        return data || [];
    },
};